/*
 * サブシステム名：マスタ管理
 * 機能名：品名マスタ登録
 */
import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'

import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import validators from '@/rahmen/validators'
import filter from '@/rahmen/utils/filters'

import header from '@/ddv2.library/header'
import message from '@/ddv2.library/messages'

const DdCodeTextBox = () => import('@/components/DdCodeTextBox.vue')
const DdDateBox = () => import('@/components/DdDateBox')
const DdDropDown = () => import('@/components/DdDropDown')
const DdEditCommonBar = () => import('@/components/DdEditCommonBar')
const DdNumericBox = () => import('@/components/DdNumericBox.vue')
const DdRadioButton = () => import('@/components/DdRadioButton')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdTextBox = () => import('@/components/DdTextBox')

export default {
  name: 'MstHinmeiEdit',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdCodeTextBox,
    DdDateBox,
    DdDropDown,
    DdEditCommonBar,
    DdNumericBox,
    DdSubHeader,
    DdTextBox,
    DdRadioButton
  },
  data: () => ({
    id: 0,
    copyMode: false,
    rec: {},
    invalidMessages: {},
    modeOfEdit: 2,
    modeKengen: 2,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    showCopyDialog: false
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      shubetsuList: 'DDMasters/mstShubetsu',
      kubunList: 'DDMasters/msysKubun',
      kihonJohoList: 'DDMasters/mstKihonJoho'
    }),
    filteredTorihikisakiList () {
      // 得意先を出力
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tokuisakiFlg === true && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    isDeleteDisable () {
      return this.id === 0
    },
    filteredTaniSyubetsu () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SVI001')
    },
    filteredHinsyuSyubetsu () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVIJ02')
    },
    filteredUnchinKeisanHouhouKubun () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF055')
    },
    filteredSuryouKeisanHouhouKubun () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF086')
    },
    filteredSyouhinUriageKubun () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF085')
    },
    filteredHacchusakiHinsyuSyubetsu () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVIJ03')
    },
    filteredHacchusakiUnchinKeisanHouhouKubun () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF087')
    },
    filteredHacchusakiSuryoKeisanHouhouKubun () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF086')
    },
    filteredHacchusakiSyouhinShiharaiKubun () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF085')
    },
    filteredITPSuryoJyuryoHandanKubun () {
      return this.kubunList.filter(function (elem) {
        return elem.kbnShuruiCd === 'KBN003'
      }).map(function (elem) {
        elem.code = elem.code.trim()
        return elem
      })
    },
    isShoukaiMode () {
      return this.modeOfEdit === 1
    },
    isRirekiFukusyaDisplay () {
      console.log('モード', this.modeOfEdit, this.modeKengen)
      if (this.modeOfEdit === 2 && (this.modeKengen === 1 || this.modeKengen === 2)) {
        return true
      }
      return false
    },
    isCancelButtonDisplay () {
      if (this.modeKengen === 0 || this.modeOfEdit === 1) {
        return false
      }
      return true
    },
    isDeleteButtonDisplay () {
      // if (this.modeKengen === 2 && (this.modeOfEdit === 0 || this.modeOfEdit === 2)) {
      if (this.modeKengen === 2 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isCopyButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isSaveButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1) {
        return true
      }
      return false
    },
    calcSuryoIntegerDigit () {
      if (this.kihonJohoList && this.kihonJohoList[0] && this.kihonJohoList[0].suryoNumericLen) {
        return this.kihonJohoList[0].suryoNumericLen
      } else {
        return 10
      }
    },
    calcSuryoMinorDigit () {
      if (this.kihonJohoList && this.kihonJohoList[0] && this.kihonJohoList[0].suryoDecimalLen) {
        return this.kihonJohoList[0].suryoDecimalLen
      } else {
        return 4
      }
    },
    calcSuryoMax () {
      return Math.pow(10, this.calcSuryoIntegerDigit) - Math.pow(10, -1 * this.calcSuryoMinorDigit)
    },
    calcJuryoIntegerDigit () {
      if (this.kihonJohoList && this.kihonJohoList[0] && this.kihonJohoList[0].juryoNumericLen) {
        return this.kihonJohoList[0].juryoNumericLen
      } else {
        return 10
      }
    },
    calcJuryoMinorDigit () {
      if (this.kihonJohoList && this.kihonJohoList[0] && this.kihonJohoList[0].juryoDecimalLen) {
        return this.kihonJohoList[0].juryoDecimalLen
      } else {
        return 4
      }
    },
    calcJuryoMax () {
      return Math.pow(10, this.calcJuryoIntegerDigit) - Math.pow(10, -1 * this.calcJuryoMinorDigit)
    }
  },
  created () {
    this.id = this.$route.params.id
    if (this.id === '0') {
      this.id = 0
    }
  },
  mounted () {
    this.initialize()
    console.log('ITP', this.filteredITPSuryoJyuryoHandanKubun)
  },
  methods: {
    getCloneTargetMethod: function () {
      return this.rec
    },
    beforeRouteLeaveByMenu: function (next) {
      const opt = {
        nextCallback: next
      }

      this.preventTransition(opt)
    },
    fetchData: function () {
      const self = this
      return new Promise((resolve) => {
        console.log('★fetchData', self)
        console.log('★going to get', self.id)
        this.HttpClient
          .get(`/api/v1/MstHinmei/find?id=${self.id}`)
          .then((data) => {
            self.rec = data.payload
            // this.rec.tekiyoStartYmd = filter.dateFormatter(this.rec.tekiyoStartYmd)
            // this.rec.tekiyoEndYmd = filter.dateFormatter(this.rec.tekiyoEndYmd)
            delete this.rec.tekiyoStartYmd
            delete this.rec.tekiyoEndYmd

            self.rec.unitKbn = [undefined, null, ''].includes(self.rec.unitKbn) ? null : self.rec.unitKbn
            self.rec.hinshuSbt = [undefined, null, ''].includes(self.rec.hinshuSbt) ? null : self.rec.hinshuSbt
            self.rec.hinUriageKbn = [undefined, null, ''].includes(self.rec.hinUriageKbn) ? null : self.rec.hinUriageKbn
            self.rec.unchinKeisanKbn = [undefined, null, ''].includes(self.rec.unchinKeisanKbn) ? null : self.rec.unchinKeisanKbn
            self.rec.suryoKeisanKbn = [undefined, null, ''].includes(self.rec.suryoKeisanKbn) ? null : self.rec.suryoKeisanKbn
            self.rec.hacchusakiHinshuKbn = [undefined, null, ''].includes(self.rec.hacchusakiHinshuKbn) ? null : self.rec.hacchusakiHinshuKbn
            self.rec.hacchusakiHinShiharaiKbn = [undefined, null, ''].includes(self.rec.hacchusakiHinShiharaiKbn) ? null : self.rec.hacchusakiHinShiharaiKbn
            self.rec.hacchusakiUnchinKeisanKbn = [undefined, null, ''].includes(self.rec.hacchusakiUnchinKeisanKbn) ? null : self.rec.hacchusakiUnchinKeisanKbn
            self.rec.hacchusakiSuryoKeisanKbn = [undefined, null, ''].includes(self.rec.hacchusakiSuryoKeisanKbn) ? null : self.rec.hacchusakiSuryoKeisanKbn

            console.log('recived data', this.rec)
            resolve()
          })
      })
    },
    initialize () {
      const self = this
      const option = {
        loadMasters: ['msttorihikisaki', 'msyskubun', 'mstshubetsu', 'mstkihonjoho'],
        initializeInputPromise: () => {
          return new Promise((resolve) => {
            self.rec = {
              hyojiOrder: '9999',
              itpSuryoJuryoKbn: '01',
              tekiyoStartYmdString: '2000/01/01',
              tekiyoEndYmdString: '2100/01/01',
              hacchusakiMeisaiShokeiFlg: true,
              meisaiShokeiFlg: true,

              torihikisakiCd: '',
              hinmeiCd: '',
              hinmeiNm: '',
              hinmeiSeishikiNm: '',
              hinmeiNmKana: '',
              hinLot: '',
              hinIrisu: '',
              hinJuuryo: '',
              hinNisugata: '',
              tanka: '',
              hacchusakiTanka: '',

              unitKbn: null,
              hinshuSbt: null,
              hinUriageKbn: null,
              unchinKeisanKbn: null,
              suryoKeisanKbn: null,
              hacchusakiHinshuKbn: null,
              hacchusakiHinShiharaiKbn: null,
              hacchusakiUnchinKeisanKbn: null,
              hacchusakiSuryoKeisanKbn: null
            }
            console.log('initializeInputPromise')
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          return new Promise((resolve) => {
            console.log('★savedInputRestorePromise', c)
            console.log('★savedInputRestorePromise', self.rec)
            // ユーザ保存項目の復元
            self.rec = { ...self.rec, ...c }
            console.log('★savedInputRestorePromise', self.rec)
            resolve()
          })
        },
        existsIdMethod: () => {
          return self.id !== 0
        },
        requestApiPromise: self.fetchData,
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            // thisId == 0 then 新規モード
            if (self.id === 0) {
              self.modeOfEdit = 0 // 新規モード
            } else if (this.modeKengen === 0) {
              self.modeOfEdit = 1 // 照会モード
            } else {
              self.modeOfEdit = 2 // 更新モード
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        },
        settingItemMethod: (kengen) => {
          console.log('settingItemMethod', kengen)
        }
      }
      console.info('call initializeForRegister', this.initializeForRegister, option)
      this.initializeForRegister(option)
    },
    onReturnButtonClick: function (e) {
      console.log('onReturnButtonClick', e)
      const self = this
      const opt = {
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }

      this.transitionBack(opt)
    },
    onCancelButtonClick: function (e) {
      console.log('onCancelButtonClick', e)
      const self = this
      const opt = {
        restoreInputsPromise: function (data) {
          return new Promise(resolve => {
            self.rec = data()
            self.rec.id = self.id
            resolve()
          })
        }
      }

      this.cancelInputs(opt)
    },
    onDeleteButtonClick: function (e) {
      const self = this
      const opt = {
        deleteRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.delete(`/api/v1/MstHinmei/Delete?id=${self.id}&tm=${self.rec.timestamp}`).then(data => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }
      this.delete(opt)
    },
    onCopyButtonClick: function (e) {
      const self = this
      const opt = {
        setIdMethod: () => {
          self.id = 0
          self.rec.id = 0
          self.modeOfEdit = 0
          self.copyMode = true
          console.log('clear id', this.rec)
        }
      }
      this.copyInputs(opt)
    },
    onSaveButtonClick: function (e) {
      console.log('save', this)
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.id = data.payload.id
            self.copyMode = false
            resolve()
          })
        },
        judgeKeyChangedMethod: (data) => {
          return data.hinmeiCd !== this.rec.hinmeiCd
        },
        getIdMethod: () => {
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            this.id = id
            this.transition(1, { id: id }, this.initialize)
            console.log('★transition')
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          return self.id !== 0
        },
        getSavedInputMethod: function () {
          console.log('★getSavedInputMethod:', self.rec.itpSuryoJuryoKbn)
          return {
            itpSuryoJuryoKbn: self.rec.itpSuryoJuryoKbn
          }
        }
      }

      this.register(opt)
    },
    registerPromise: function () {
      let f
      if (this.id === 0) {
        console.log('★登録処理')
        console.log('★rec', this.rec)
        f = this.HttpClient.post('/api/v1/MstHinmei/Create', this.rec)
      } else {
        console.log('★更新処理')
        console.log('★rec', this.rec)
        f = this.HttpClient.put(`/api/v1/MstHinmei/Update?id=${this.id}`, this.rec)
      }
      return f
    },
    registerValidate: function () {
      var ret = true
      console.log('validate start', this.cloneData)
      const msg = validators.compareDate(this.rec.tekiyoStartYmdString, this.rec.tekiyoEndYmdString)
      console.log('date check end', msg)
      if (msg !== undefined) {
        this.$refs.tekiyoStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.tekiyoEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.setInvalidSummaryMessage('COME0014')
        ret = false
      }
      console.log('cloneData', this.cloneData)
      return ret
    },
    deleteValidate: function () {
      if (this.cloneData.hinmeiCd !== this.rec.hinmeiCd) {
        this.$refs.hinmeiCd[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0121', ['品名コード']))
        this.setInvalidSummaryMessage('COME0015')
        return false
      }
      return true
    }
  }
}
